<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'meuspromotores') {
            next({ name: 'meuspromotores-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'meuspromotores') {
            this.$router.push({ name: 'meuspromotores-list' });
        }
    },
};
</script>
